import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreBlogTags } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية لوسوم المدونة
 */
export function useRestoreAllBlogTags() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllBlogTagsMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreBlogTags,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore blog tags");
        },
    });

    return {
        restoreAllBlogTagsMutate,
        isPending,
    };
}
